import React from "react"
import { observer } from "mobx-react-lite"
import get from "lodash/get"

import { useController, useStore } from "@store/index"
import TextInput from "@components/ui/TextInput/TextInput"
import { SUBSCRIPTION_OPTION_LABELS } from "@framework/constants/subscription"
import Text from "@components/ui/Typography/Text"

import StatusText from "./StatusText"

import styles from "./index.module.sass"

export interface SimpleTableProps {
  optionName: string
  unit?: string
  defaultValue?: string
}

export const EditInput: React.FC<SimpleTableProps> = observer(
  ({ optionName, unit, defaultValue }) => {
    const { subscriptionStore } = useStore()
    const { subscriptionController } = useController()
    const { data, isEditable } = subscriptionStore

    const value = get(data, optionName, defaultValue)

    const onTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      subscriptionController.updateEditData(optionName, e.target.value)
    }

    const displayUnit = unit ?? SUBSCRIPTION_OPTION_LABELS[optionName]

    return isEditable ? (
      <div className={styles.editSelectRow}>
        <TextInput
          name={optionName}
          defaultValue={value}
          onChange={onTextChange}
          onBlur={onTextChange}
          type="number"
          after={
            <Text
              className={styles.inputEnd}
              variant="inherit"
              color="text50Color"
            >
              {displayUnit}
            </Text>
          }
          className={styles.textInputCustom}
        />
      </div>
    ) : (
      <StatusText text={value != null ? `${value} ${displayUnit}` : "N/A"} />
    )
  }
)

export default EditInput
